import * as React from 'react';
import Providers from '../../containers/Providers';
import Overview from '../../containers/Overview';

const SitemapOverview = () => {
  return (
    <Providers>
      <Overview />
    </Providers>
  );
};

export default SitemapOverview;
